import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import RightContent from 'app/components/layouts/MenuRight/RightContent';
import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import { faVolumeUp } from "@fortawesome/free-solid-svg-icons";
import SelectForm from 'app/commons/components/SelectForm';
import SearchForm from 'app/commons/components/SearchForm';
import { withGlobalData } from 'app/utils/withGlobalData';
import * as categoryApi from 'app/requests/categories';
import { useState, useEffect, useMemo } from 'react';
import { buildParams } from 'app/utils/pagination';
import * as listenApi from 'app/requests/listens';
import Title from 'app/components/layouts/Title';
import Image from 'app/components/layouts/Image';
import { useTranslation } from 'next-i18next';
import { setNewParams } from 'app/utils/ga';
import { Category } from 'types/category';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import first from 'lodash/first';
import Link from 'next/link';
import env from '.env.json';

import dynamic from "next/dynamic";
const BarSound = dynamic(() => import("app/components/layouts/BarSound/Index"), { ssr: false });
var audio: any = null;

export default function Index({ quotations, categories }) {
  const router = useRouter()
  const { t } = useTranslation();
  const code = router.locale == 'en' ? 'vi' : router.locale;

  const defaultParam = {
    keyword: router.query.keyword || '',
    page: 1
  };

  const [params, setParams] = useState(defaultParam);
  const [isChange, setIsChange] = useState(false);
  const [quotationActive, setquotationActive] = useState<string | null>(null);

  useEffect(() => {
    if (isChange) {
      changeUrl(router.query.type as string);
    }
    setIsChange(true);
  }, [params]);

  const contentRight = useMemo(() => {
    return <div className="justify-content-center flex-wrap">
      {
        (categories || [])?.map((category: Category, index: number) => {
          return (
            <Link
              className={`grammar ${category.slug === router.query.type ? 'active-box' : ''}`}
              key={index} href={`/quotations/${category.slug}`}
            >
              <Image
                style={{ maxWidth: 40 }}
                src={`/images/commons/poem.webp`}
                alt={category.title[router.locale || 'vi']}
              />
              <span>
                {category.title[router.locale || 'vi']}
              </span>
            </Link>
          )
        })
      }
    </div>
  }, [categories, router.locale, router.query.type]);

  const optionCategories = useMemo(() => {
    return categories.map((category: Category) => {
      return (
        <option value={category.slug} key={category.slug}>
          {category.title[router.locale || 'vi']}
        </option>
      )
    });
  }, [categories]);

  const changeUrl = (type: string) => {
    const url = `/quotations/${type}${buildParams(params)}`
    router.push(url, url)
  }

  const setDataParams = (value: string | number, name: string, page: number | null = null) => {
    setNewParams(setParams, params, value, name, page);
  }

  const playAudio = (url: string, id: string) => {
    if (audio) {
      audio.pause();
      audio.removeEventListener('ended', function () {
        setquotationActive(null);
      });
    }

    audio = new Audio(`${env.URL_API_NODE}/${url}`);
    setquotationActive(id);
    audio.play();
    audio.addEventListener('ended', function () {
      setquotationActive(null);
    });
  }

  return (
    <section className="box-card-area">
      <NextSeo
        title={t('routes.quotations_des')}
        description={t('routes.quotations_des')}
        additionalMetaTags={[{
          name: 'keywords',
          content: 'danh ngôn tiếng anh, danh ngôn tiêng anh theo chủ đề'
        }]}
      />
      <div className="container-md">
        <div className="d-flex">
          <div className="box-news-area">
            <div className='content_inner'>
              <Title title='routes.quotations_des' />
              <div className="mt-3 row d-lg-none">
                <div className='mx-auto position-relative col-md-6'>
                  <SearchForm setDataParams={setDataParams} />
                </div>
                <div className='category col-md-6'>
                  <SelectForm
                    value={router.query.type}
                    handleChange={(value: string) => changeUrl(value)}
                    options={optionCategories}
                    showOptionBlank={false}
                  />
                </div>
              </div>
              {quotations?.data?.length > 0 &&
                <div className="mt-4 quotation-box">
                  {
                    quotations?.data.map((quotation) => {
                      return (
                        <div className="mb-3 wrap-box-content position-relative" key={quotation.title_en}>
                          <div
                            className="d-flex ml-2 tool-tip"
                            title-new={first(quotation.translates)[code]}
                            onClick={() => playAudio(quotation.audio_url, quotation._id)}
                          >
                            <Image
                              width={50}
                              height={50}
                              className="image-quotation mr-3 my-auto"
                              alt={quotation.title_en}
                              style={{ minWidth: 50 }}
                              src={`/images/commons/quotations.webp`}
                            />
                            <div className="overflow-hidden">
                              <div className="wrap-box-title text-left">
                                {quotation.title_en}
                              </div>
                              <span className="float-left">
                                <span className='text-info font-weight-bold float-left'>{quotation.author}</span>
                                <small className='pl-2 display-none-mobile'>{quotation.publication}</small>
                              </span>
                            </div>
                            {quotationActive != quotation._id &&
                              <FontAwesomeIcon
                                icon={faVolumeUp}
                                className='position-relative text-secondary ml-auto mr-2 mt-1'
                              />
                            }
                            {quotationActive == quotation._id &&
                              <BarSound />
                            }
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
              }
              {!quotations?.data?.length &&
                <div className='text-danger text-center mt-3 text-size-xl'>
                  {t('commons.result_notfound')}
                </div>
              }
            </div>
          </div>
          <RightContent
            title={t('quotations.category')}
            contentRight={contentRight}
          />
        </div>
      </div>
    </section>
  )
}

export const getServerSideProps = withGlobalData(async ({ locale, query }) => {
  try {
    const [quotations, categories, translations] = await Promise.all([
      listenApi.getQuotations({
        ...query,
        code: locale,
        direction: 'asc',
        limit: 50,
        from: 'home_page',
      }),
      categoryApi.list({
        type: 'quotation',
        code: locale,
      }),
      serverSideTranslations(locale, ['common']),
    ]);

    return {
      props: {
        ...translations,
        quotations,
        categories: categories?.data,
      },
    };
  } catch (error) {
    return { notFound: true };
  }
});
